export default "__VITE_ASSET__BSZ$rMLS__"